import * as React from 'react';
export const IcRuler = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.41 6.59l-3-3a2 2 0 00-2.82 0l-.3.29 1.42 1.41a1 1 0 01-.326 1.639 1 1 0 01-1.094-.22l-1.41-1.42-1.59 1.59 3.42 3.41a1 1 0 01-.326 1.64 1.002 1.002 0 01-1.094-.22L9.88 8.29 8.29 9.88l1.42 1.41a1 1 0 010 1.42 1.001 1.001 0 01-1.42 0l-1.41-1.42-1.59 1.59 3.42 3.41a1 1 0 01-.326 1.64 1.001 1.001 0 01-1.094-.22l-3.41-3.42-.29.3a2 2 0 000 2.82l3 3a2 2 0 002.82 0l11-11a2 2 0 000-2.82z'
      fill='currentColor'
    />
  </svg>
);
